import { render, staticRenderFns } from "./TestimonialTwo.vue?vue&type=template&id=7e3c63b0&scoped=true&"
var script = {}
import style0 from "./TestimonialTwo.vue?vue&type=style&index=0&id=7e3c63b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3c63b0",
  null
  
)

export default component.exports